export default function TitleDescLeft({ data, children, className }) {
  return (
    <>
      <div className={`container ${className}`}>
        <div className={`${data.isContentLong ? `lg:maxw-xl` : `lg:maxw-md`}`}>
          <h2 className="text-lg lg:mb-3 md:mb-2">{data.title}</h2>
          <p>{data.desc}</p>
        </div>
        {children}
      </div>
    </>
  );
}
